import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useState } from 'react';
import { PropTypes, describe } from 'react-desc';
import DSDropdownMenu from '@elliemae/ds-dropdownmenu';
import ChevronDown from '@elliemae/ds-icons/ChevronDown';
import useFocusGroupItem from '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import { Pill } from './Pill.js';
import '@elliemae/ds-classnames';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function DropdownPill(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      variant = _ref.variant,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex,
      _ref$closeMenuOnItemS = _ref.closeMenuOnItemSelection,
      closeMenuOnItemSelection = _ref$closeMenuOnItemS === void 0 ? false : _ref$closeMenuOnItemS,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      dropdownProps = _objectWithoutProperties(_ref, ["containerProps", "label", "variant", "tabIndex", "closeMenuOnItemSelection", "maxWidth", "minWidth"]);

  var ref = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      chevronEl = _useState2[0],
      chevronRef = _useState2[1];

  var _useFocusGroupItem = useFocusGroupItem(ref),
      focusFirst = _useFocusGroupItem.focusFirst;

  return /*#__PURE__*/React.createElement(DSDropdownMenu, _extends({}, dropdownProps, {
    closeMenuOnItemSelection: closeMenuOnItemSelection,
    maxWidth: maxWidth,
    hideIfNotVisible: true,
    menuProps: {
      className: 'dropdown-pill-menu',
      zIndex: 100
    },
    minWidth: minWidth,
    onClose: focusFirst,
    referenceNode: chevronEl,
    triggerComponent: /*#__PURE__*/React.createElement(Pill, {
      className: "dropdown-pill",
      containerProps: _objectSpread({
        role: 'listbox'
      }, containerProps),
      innerRef: ref,
      label: label,
      rightAddon: /*#__PURE__*/React.createElement("div", {
        ref: chevronRef
      }, /*#__PURE__*/React.createElement(ChevronDown, {
        className: "dropdown-pill-chevron-down",
        "data-testid": "dropdown-pill-button"
      })),
      tabIndex: tabIndex,
      variant: variant
    })
  }));
}

var props = {
  /** props injected to component wrapper */
  containerProps: PropTypes.object.description('props injected to component wrapper'),

  /** labeled pill text label */
  label: PropTypes.string.isRequired.description('pill text label'),

  /** pill variant */
  variant: PropTypes.oneOf(['value', 'title']).description('pill variant'),

  /** html focus border */
  tabIndex: PropTypes.number.description('html focus order'),

  /** close menu on item selection */
  closeMenuOnItemSelection: PropTypes.bool.description('close menu on item selection'),

  /** pill max width */
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('pill max width'),

  /** pill min width */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('pill min width')
};
DropdownPill.propTypes = props;
var DSDropdownPillWithSchema = describe(DropdownPill);
DSDropdownPillWithSchema.propTypes = props;

export { DSDropdownPillWithSchema, DropdownPill };
//# sourceMappingURL=DropdownPill.js.map
